import React, { lazy, Suspense } from 'react';
import Canonical from '../../seo/Canonical';
import Footer from '../Layouts/Footer';
import './PricingPage.css';

const FBAPricing = lazy(() => import('../AmazonFBA/Fbapricing'));

const FulfilmentCalculatorPage: React.FC = () => {
  return (
    <div className="pricing-page logistics-page">
      <Canonical baseUrl="https://www.pickpackpro.co.uk" />

      <header className="pricing-hero" style={{ padding: '80px 20px 40px', textAlign: 'center', background: '#f8fafc' }}>
        <h1 style={{ fontSize: '2.5rem', fontWeight: 800, color: '#0f172a', marginBottom: '16px' }}>
          Interactive Fulfilment Cost Calculator
        </h1>
        <p style={{ fontSize: '1.125rem', color: '#475569', maxWidth: '600px', margin: '0 auto' }}>
          Use our interactive tool to model your Amazon FBA prep and ecommerce pick and pack costs. 
          See how our transparent tiers scale with your monthly volume.
        </p>
      </header>

      <Suspense fallback={<div style={{ padding: '100px', textAlign: 'center' }}>Loading calculator...</div>}>
        <FBAPricing
          showQuickEstimate
          headingTitle="Calculate Your UK 3PL & Prep Costs"
          headingSubtitle="Instantly estimate your fulfilment fees based on your product profile and monthly order volume."
        />
      </Suspense>

      <Footer />
    </div>
  );
};

export default FulfilmentCalculatorPage;
